// useAdjuntosXL - Sprint 44 Fase 3 Vista 10.
import { useCallback, useEffect, useState } from 'react';
import {
  listAdjuntos, uploadAdjunto, deleteAdjunto,
} from '../services/adjuntosService';

export default function useAdjuntosXL(importacionId) {
  const [items, setItems] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!importacionId) return;
    setLoading(true);
    setError(null);
    try {
      const r = await listAdjuntos(importacionId);
      setItems(r.items);
      setTipos(r.tiposDocumento);
    } catch (e) {
      setError((e && e.message) || 'Error cargando adjuntos');
    } finally {
      setLoading(false);
    }
  }, [importacionId]);

  useEffect(() => { refetch(); }, [refetch]);

  const upload = useCallback(async ({ file, tipoDocumento, notas }) => {
    if (!importacionId) throw new Error('Falta importacionId');
    const created = await uploadAdjunto(importacionId, { file, tipoDocumento, notas });
    await refetch();
    return created;
  }, [importacionId, refetch]);

  const remove = useCallback(async (adjuntoId) => {
    await deleteAdjunto(adjuntoId);
    await refetch();
  }, [refetch]);

  return { items, tipos, loading, error, refetch, upload, remove };
}
